import script from "./SignupForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupForm.vue?vue&type=script&setup=true&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=2d43a5cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d43a5cc"]])

export default __exports__